import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

export const PaymentTabList = styled(TabList, { label: 'PaymentTabList' })(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.grey[100],
}));

export const PaymentTab = styled(Tab, { label: 'PaymentTab' })(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.grey[300]}`,

  '&.Mui-selected': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const PaymentTabPanel = styled(TabPanel, {
  label: 'PaymentTabPanel',
})(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  flex: '1 1 100%',
  overflowY: 'auto',
}));

export const PaymentTabsRoot = styled('div', {
  label: 'PaymentTabsRoot',
})(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));
